import { Box, Container, Grid, Typography } from '@mui/material';
import { ArticleMeta } from 'types/blog';
import ArticleCard from './ArticleCard';

// ==============================|| 関連記事 ||============================== //
//
// 記事データの related に並べた slug から作る。
// 記事同士を内部リンクでつないでおくと、読者の回遊が増えるだけでなく、
// 新しい記事にクローラーが早く到達する(一覧からの1本の導線だけに頼らずに済む)。

const RelatedArticles = ({ articles }: { articles: ArticleMeta[] }) => {
    if (articles.length === 0) {
        return null;
    }

    return (
        <Box component="section" sx={{ py: { xs: 6, md: 8 }, bgcolor: '#f8fafa' }}>
            <Container maxWidth="md">
                <Typography component="h2" sx={{ fontSize: { xs: '1.15rem', md: '1.3rem' }, fontWeight: 900, color: '#0f3d43', mb: 3 }}>
                    あわせて読みたい
                </Typography>
                <Grid container spacing={2.5}>
                    {articles.map((article) => (
                        <Grid item xs={12} sm={6} key={article.slug}>
                            <ArticleCard article={article} />
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default RelatedArticles;
